module.exports = __webpack_public_path__ + "img/blog2.97910660.jpg";